<div class="container">
    <div class="row">
        <div class="grid">
            <div class="one-whole">
                <h2 style="color: #003478;">OAuth Realm Details Properties</h2>
                <p>The properties relating to a realm</p>
                <div class="one-whole">
                    <div class="one-third" style="float:left;"></div>
                    <div class="one-third" style="float:right;">
                        <button (click)="openPopUp(addPopup) " style="float: right;
                        margin: 0 0 5px;
                        background-color: #003478;
                        font-family: Verdana, Geneva, sans-serif;
                        display: inline-block;
                        border:none;
                        cursor:pointer;
                        border-radius: 5px;
                        font-weight: 400;
                        color: white; 
                        letter-spacing: 0.5px;
                        font-size: 12px;
                        line-height: 12px;
                        padding: 10px 20px;
                        padding-top: 10px;
                        padding-right: 20px;
                        padding-bottom: 10px;
                        padding-left: 20px">{{'ADD'|translate}}</button>
                    </div>
                    <span class="error" name="generaldel" style="margin-top:0px!important;display: none;"></span>
                    <h4 style="color: #003478;">Properties for DID Service QA</h4>
                    <table class="table__thin tablesorter table">
                        <thead class="table__headings">
                            <tr>
                                <th style="width:45%;">{{'Property Name'|translate}}</th>
                                <th style="width:45%;">{{'Property Value'|translate}}</th>
                                <th class="sorter-false" style="width:10%;"></th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr *ngFor="let i of property;">
                                <td>
                                    {{i.name}}
                                </td>
                                <td>
                                    {{i.value}}
                                </td>
                                <td class="buttontd">
                                    <input property="Delete" style="float: right;
                                    margin: 0 0 5px;
                                    background-color: #003478;
                                    font-family: Verdana, Geneva, sans-serif;
                                    display: inline-block;
                                    border:none;
                                    cursor:pointer;
                                    border-radius: 5px;
                                    font-weight: 400;
                                    color: white; 
                                    letter-spacing: 0.5px;
                                    font-size: 12px;
                                    line-height: 12px;
                                    padding: 10px 20px;
                                    padding-top: 10px;
                                    padding-right: 20px;
                                    padding-bottom: 10px;
                                    padding-left: 20px" (click)="removeProperty(i.name,i.value,i.oauth_realm_id);"
                                        type="button" value="{{'DELETE'|translate}}">
                                </td>
                            </tr>

                            <!-- <tr>
                                <td>
                                    resource
                                </td>
                                <td>
                                    urn:dnf:pcf:dealerInformationeuservicev1:qa
                                </td>
                                <td class="buttontd">
                                    <input property="Delete" style="margin-top:0px;"
                                        onclick="removeProperty('resource', '9002', translations.deleteConfirmation);"
                                        type="button" value="Delete">
                                </td>
                            </tr> -->
                        </tbody>
                    </table>
                    <ng-template #addPopup let-modal>
                        <div class="ui-dialog  ui-widget-content ui-corner-all ui-front ui-dialog-buttons ui-draggable"
                            tabindex="-1" role="dialog" style="height: auto; width: 520px;display: block;"
                            aria-describedby="add-form-dialog" aria-labelledby="ui-id-1">
                            <div class="ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix">
                                <span id="ui-id-1" class="ui-dialog-title">{{'Add a new realm details property'|translate}}</span>
                                <i class="fa fa-times mng-qualifier-close-btn close-oauth-popup"
                                    (click)="modal.dismiss('Cross click')" title="close"></i>
                                <!-- <button
                                    class="ui-button ui-widget ui-state-default ui-corner-all ui-button-icon-only ui-dialog-titlebar-close"
                                    role="button" aria-disabled="false" title="close"><span
                                        class="ui-button-icon-primary ui-icon ui-icon-closethick"></span><span
                                        class="ui-button-text">close</span></button> -->
                            </div>

                            <div id="add-form-dialog" class="ui-dialog-content ui-widget-content"
                                style=" width: auto; min-height: 0px; max-height: none; height: 185.8px;">
                                <form name="oAuthPropertiesForm"
                                    style="width:100%;" id="oAuthPropertiesForm">
                                    <!-- <span class="error" name="general" style="display: none;"></span> -->
                                    {{'Property Name'|translate}}
                                    <!-- <input class="form-control item" type="text" name="name"> -->
                                   
                                    <input type="text" name="name" (keyup)="number($event)" (change)="number($event)" [(ngModel)]="propertyName" style="width:100%;"
                                        id="name">
                                        <div *ngIf="nameError" class="error-border" style = "color: black">
                                            <span class="fa fa-exclamation-triangle" style = "color: red"></span>&nbsp;
                                            <span style="color:black">{{'Please specify the realm details properties name'|translate}}</span>
                                        </div>
                                        <div *ngIf ="charNum" class="error-border">
                                            <span class="fa fa-exclamation-triangle"></span>&nbsp;
                                            <span style="color:black">{{'The realm details properties name given is too long'|translate}}</span>
                                        </div>
                                        <div *ngIf ="duplicateName" class="error-border">
                                            <span class="fa fa-exclamation-triangle"></span>&nbsp;
                                            <span style="color:black">Cannot use a name that is already in use by a different property of this details</span>
                                        </div>
                                        <br>

                                    {{'Property Value'|translate}}
                                    <!-- <input class="form-control item" type="text" name="value"> -->
                                    <input type="text" name="value" (keyup)="value($event)" [(ngModel)]="propertyValue" style="width:100%;"
                                        id="value">
                                        <div *ngIf="valueError" class="error-border" style = "color: black">
                                            <span class="fa fa-exclamation-triangle" style = "color: red"></span>&nbsp;
                                            <span style = "color: black">{{'Please specify the realm details properties value'|translate}}</span>
                                        </div>
                                       <!-- <span *ngIf ="valueError" style=color:red >Please specify the realm details properties value</span> -->
                                       <br>
                                       <div *ngIf="charValue" class="error-border" style = "color: black">
                                        <span class="fa fa-exclamation-triangle" style = "color: red"></span>&nbsp;
                                        <span style = "color: black">{{'The realm details properties value given is too long'|translate}}</span>
                                    </div>
                                        
                                        <!-- <input type="hidden" name="detailsId" value="9002" id="detailsId"> -->
                                </form>
                            </div>
                            <!-- <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
                        <div class="ui-dialog-buttonset"><button type="button"
                                class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"
                                role="button" aria-disabled="false"><span class="ui-button-text">Close</span></button>
                            <button type="button"
                                class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"
                                role="button" aria-disabled="false">
                                <span class="ui-button-text">Add</span></button>
                        </div>
                    </div> -->
                            <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
                                <div class="ui-dialog-buttonset"><button type="button" 
                                        class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"
                                        role="button" aria-disabled="false" ><span
                                            class="ui-button-text" (click)="modal.dismiss('Cross click')">{{'CLOSE'|translate}}</span></button><button type="button"
                                        class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"
                                        role="button" aria-disabled="false" (click)="addProperty()"><span
                                            class="ui-button-text">{{'ADD'|translate}}</span></button>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>